import { Box } from '@chakra-ui/react';
import React from 'react';

export default function CardContainer({ children, ...rest }) {
    return (
        <Box
            bg={'white'}
            p={'24px'}
            border={'1px solid'}
            borderColor={'neutral.100'}
            borderRadius={'8px'}
            boxShadow={'sm'}
            {...rest}
        >
            {children}
        </Box>
    );
}
